"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getListContainerWidth = void 0;

var _react = _interopRequireDefault(require("react"));

var _pureReactCarousel = require("pure-react-carousel");

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _SlideshowStepper = _interopRequireDefault(require("../SlideshowStepper"));

var _useStyle = _interopRequireDefault(require("./useStyle"));

var _withSlideCount = _interopRequireDefault(require("../withSlideCount"));

var _SlideshowNext = _interopRequireDefault(require("../SlideshowNext"));

var _SlideshowBack = _interopRequireDefault(require("../SlideshowBack"));

var _SlideshowSlide = _interopRequireDefault(require("../SlideshowSlide"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var getListContainerWidth = function getListContainerWidth(innerRef, numberOfSlides, numberOfVisibleSlides) {
  var _React$useState = _react["default"].useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      width = _React$useState2[0],
      setWidth = _React$useState2[1];

  _react["default"].useLayoutEffect(function () {
    var num = 0;

    try {
      num = parseFloat(innerRef.current.querySelector('ul').style.width) / numberOfSlides;
    } catch (e) {
      num = 100 / numberOfSlides;
    }

    setWidth(num);
  }, [numberOfVisibleSlides]);

  return width;
};

exports.getListContainerWidth = getListContainerWidth;

var _default = (0, _withSlideCount["default"])(function (_ref) {
  var data = _ref.data,
      visibleSlides = _ref.visibleSlides,
      Slide = _ref.component,
      rest = _objectWithoutProperties(_ref, ["data", "visibleSlides", "component"]);

  var ref = _react["default"].useRef();

  var width = getListContainerWidth(ref, data.length, visibleSlides);
  var cls = (0, _useStyle["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    maxWidth: "xl"
  }, /*#__PURE__*/_react["default"].createElement(_pureReactCarousel.CarouselProvider, _extends({
    visibleSlides: visibleSlides
  }, rest), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    alignItems: "center",
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_SlideshowBack["default"], null), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    className: cls.root,
    ref: ref,
    item: true,
    xs: true,
    zeroMinWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_pureReactCarousel.Slider, {
    role: undefined,
    trayProps: {
      role: 'listbox',
      'aria-label': 'Carousel listbox container'
    },
    style: {
      overflow: 'hidden'
    }
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_SlideshowSlide["default"], _extends({}, item, rest, {
      index: index,
      width: width
    }), /*#__PURE__*/_react["default"].createElement(Slide, _extends({
      currentSlide: index
    }, item, rest)));
  }))), /*#__PURE__*/_react["default"].createElement(_SlideshowNext["default"], null)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_SlideshowStepper["default"], null))));
});

exports["default"] = _default;